import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resEn from '~/locales/en.json';

const lng = navigator.language.split('-')[0];

const loadLanguage = async (lang: string) => {
  const translation = await import(`../locales/${lang}.json`);
  i18n.addResourceBundle(lang, 'translation', translation.default);
  i18n.changeLanguage(lang);
};

loadLanguage(lng);

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: resEn,
    },
  },
  lng,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
